import React from 'react';
import { Alert, Button, Space } from 'antd';
export class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false,
        };
        this.reset = () => {
            this.setState({ hasError: false, error: undefined });
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        console.error('Captured error', error, info);
    }
    render() {
        var _a, _b;
        if (this.state.hasError) {
            return ((_a = this.props.fallback) !== null && _a !== void 0 ? _a : (React.createElement(Alert, { type: "error", message: "Something went wrong", description: React.createElement(Space, { orientation: "vertical", style: { width: '100%' } },
                    React.createElement("div", null, (_b = this.state.error) === null || _b === void 0 ? void 0 : _b.message),
                    React.createElement(Button, { onClick: this.reset }, "Try again")) })));
        }
        return this.props.children;
    }
}
